// Maps a related-record type to a fetch resource + how to build a link to open it.
export const RELATED_TYPES = [
  { type: "Task", resource: "tasks", nameKey: "title", link: (r) => `/?tab=tasks&task=${r.id}` },
  { type: "Priority", resource: "priorities", nameKey: "title", link: () => `/?tab=priorities` },
  { type: "Milestone", resource: "launch-milestones", nameKey: "title", link: () => `/launch?view=overview` },
  { type: "Module", resource: "modules", nameKey: "name", link: (r) => `/product/module/${r.id}` },
  { type: "Chapter", resource: "chapters", nameKey: "name", link: () => `/product?tab=modules` },
  { type: "Campaign", resource: "marketing-campaigns", nameKey: "name", link: () => `/marketing?tab=campaigns` },
  { type: "Investor", resource: "investors", nameKey: "name", link: (r) => `/investors/${r.id}` },
  { type: "Decision", resource: "decisions", nameKey: "title", link: () => `/decisions?tab=decisions` },
  { type: "Risk", resource: "risks", nameKey: "title", link: () => `/decisions?tab=risks` },
  { type: "Future Innovation", resource: "innovations", nameKey: "title", link: () => `/product?tab=innovations` },
  { type: "Weekly Review", resource: "weekly-reviews", nameKey: "week_start", link: (r) => `/office?tab=weekly-review&review=${r.id}` },
];

export const relatedMeta = (type) => RELATED_TYPES.find((t) => t.type === type);

export const relatedLink = (rec) => {
  const meta = relatedMeta(rec.type);
  return meta ? meta.link({ id: rec.id, week_start: rec.name }) : "/";
};
